import {
  ChargingStationsOverrideResponse,
  ChargingStationsResponse,
} from "./APITypes";
import fetchResolver, {Resolution} from "./FetchResolver";

/** Provides an interface to operations in the backend */
const API = {
  /** Attempts to get a list of current charging stations */
  getChargingStations: async (): Promise<
    Resolution<ChargingStationsResponse>
  > => {
    return fetchResolver.apiCall({path: "", backend: "chargingStations"});
  },
  /** Attempts to get a config file with overrides for the charging stations */
  getChargingStationsOverride: async (): Promise<
    Resolution<ChargingStationsOverrideResponse>
  > => {
    return fetchResolver.apiCall({
      path: "",
      backend: "chargingStationsOverride",
    });
  },
};

export default API;
